import type { ReactNode } from 'react';
import { motion } from 'motion/react';
import { popIn, useReducedMotion } from '@redpandev/ui';

/**
 * Erreur de formulaire (niveau serveur) : bloc `role="alert"` stylé danger,
 * pop-in à l'apparition (opacité seule si reduced-motion via MotionConfig).
 */
export function FormAlert({ children }: { children?: ReactNode }) {
  const reduced = useReducedMotion();
  if (!children) return null;
  return (
    <motion.p
      role="alert"
      variants={popIn}
      initial={reduced ? false : 'hidden'}
      animate="visible"
      className="flex items-start gap-2 rounded-lg border border-danger-500/40 bg-danger-500/10 px-3.5 py-2.5 text-sm font-semibold text-danger-500"
    >
      <span aria-hidden="true">⚠</span>
      <span>{children}</span>
    </motion.p>
  );
}
